<template>
  <span v-if="variant === 'mark'" class="brand-logo brand-logo--mark" role="img" aria-label="SURI&amp;">
    <span aria-hidden="true">&amp;</span>
  </span>
  <span v-else :class="['brand-logo', 'brand-logo--wordmark', `brand-logo--${tone}`]"><span class="brand-logo__word">SURI<span class="brand-logo__amp">&amp;</span></span><span v-if="sub" class="brand-logo__sub">{{ sub }}</span></span>
</template>

<script>
/**
 * @component BrandLogo
 * @description 브랜드 표기 공통 부품 (SURINP-698). 영문 표기는 SURI& 하나 — 화면에 브랜드 글자를 직접 쓰지 않는다.
 * 크기는 부모가 CSS 변수 --brand-logo-size 로 넘긴다(기본 22px). 미디어쿼리를 두지 않는다(모바일 재사용 — SURINP-753).
 */
export default {
  name: 'BrandLogo',
  props: {
    /**
     * wordmark(SURI& 글자) / mark(& 기호 사각형 — 접힌 사이드바 등 좁은 자리)
     * @type {string}
     */
    variant: {
      type: String,
      default: 'wordmark',
      validator: (v) => ['wordmark', 'mark'].includes(v)
    },
    /**
     * light(밝은 바탕) / dark(어두운 바탕 — 사이드바)
     * @type {string}
     */
    tone: {
      type: String,
      default: 'light',
      validator: (v) => ['light', 'dark'].includes(v)
    },
    /**
     * 워드마크 오른쪽 보조 표기 (예: 수리엔 CS)
     * @type {string}
     */
    sub: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
.brand-logo {
  display: inline-flex;
  align-items: baseline;
  gap: var(--space-2);
  white-space: nowrap;
}

.brand-logo__word {
  font-size: var(--brand-logo-size, 22px);
  font-weight: var(--font-weight-extrabold);
  letter-spacing: var(--letter-spacing-wide);
  line-height: 1.2;
}

.brand-logo--light .brand-logo__word {
  color: var(--color-primary-700);
}

.brand-logo--dark .brand-logo__word {
  color: var(--color-bg-white);
}

.brand-logo__amp {
  color: var(--color-accent);
}

.brand-logo__sub {
  font-size: var(--font-body-sm);
  font-weight: var(--font-weight-regular);
  color: var(--color-gray-500);
}

.brand-logo--mark {
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background: linear-gradient(135deg, var(--color-primary-500) 0%, var(--color-accent) 100%);
  font-size: var(--font-heading-lg);
  font-weight: var(--font-weight-bold);
  color: var(--color-bg-white);
}
</style>
